import React, {useEffect, useState} from 'react'
import {AppContainer} from '../../../_metronic/helpers/components/AppContainer'
import {MDBCol, MDBContainer, MDBRow} from 'mdb-react-ui-kit'
import clsx from 'clsx'
import {MdWorkOutline} from 'react-icons/md'
import {BiUser} from 'react-icons/bi'
import {RiBankCard2Line} from 'react-icons/ri'
import PrivateRequest from '../api/PrivateRequest'
import toast, {Toaster} from 'react-hot-toast'
import {useSelector} from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import {RootState} from '../../../reducer/reducer'
import {DatePicker} from 'zaman'
const moment = require('moment-jalaali')


const EditProfile = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [userInfo, setUserInfo] = useState<any>({
    name: '',
    lastname: '',
    father_name: '',
    national_code: '',
    Id: '',
    birthday_date: '',
    job_title: '',
    degree: '',
    phone_number: '',
    mobile_number: '',
    address: '',
    shaba_number: 'IR',
    bank_name: '',
    bank_account_number: '',
  })
  const UserInfoState = useSelector((state: RootState) => {
    return state.UserInfo
  })


  const changeInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setUserInfo({...userInfo, [event.target.name]: event.target.value})
  }
  useEffect(() => {
    PrivateRequest().get('/checkusersverify')
      .then(async (res: any) => {
        console.log('editProfile', res.data)
        setUserInfo({
          ...userInfo,
          name:
            res.data.user_info.personal_data === null
              ? ''
              : res.data.user_info.personal_data.name,
          lastname:
            res.data.user_info.personal_data === null
              ? ''
              : res.data.user_info.personal_data.lastname,
          father_name:
            res.data.user_info.personal_data === null
              ? ''
              : res.data.user_info.personal_data.father_name,
          national_code:
            res.data.user_info.personal_data === null
              ? ''
              : res.data.user_info.personal_data.national_code,
          birthday_date:
            res.data.user_info.personal_data === null
              ? ''
              : res.data.user_info.personal_data.birthday_date,
          degree:
            res.data.user_info.contact_data === null ? '' : res.data.user_info.contact_data.degree,
          job_title:
            res.data.user_info.contact_data === null
              ? ''
              : res.data.user_info.contact_data.job_title,
          mobile_number:
            res.data.user_info.contact_data === null
              ? ''
              : res.data.user_info.contact_data.mobile_number,
          phone_number:
            res.data.user_info.contact_data === null
              ? ''
              : res.data.user_info.contact_data.phone_number,
          address:
            res.data.user_info.contact_data === null ? '' : res.data.user_info.contact_data.address,
          bank_name:
            res.data.user_info.bank_data === null ? '' : res.data.user_info.bank_data.bank_name,
          bank_account_number:
            res.data.user_info.bank_data === null
              ? ''
              : res.data.user_info.bank_data.bank_account_number,
          shaba_number:
            res.data.user_info.bank_data === null ? 'IR' : res.data.user_info.bank_data.shaba_number,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setLoading(true)
    PrivateRequest().put('/update/user-info', userInfo)
      .then((res) => {
        setLoading(false)
        if (res.status === 200) {
          toast.success('اطلاعات شما با موفقیت بروزرسانی شد')
        }
      })
      .catch((err) => {
        setLoading(false)
        toast.error(err.response.data.err)
        console.log('err update user info', err)
      })
  }
  function submitExample({ value }: any) {
    const date = moment(value, 'YYYY-M-D HH:mm:ss').format(
      'HH:mm - jYYYY/jM/jD'
    )
    const b = new Intl.DateTimeFormat('fa-IR').format(value._d)
    console.log("value ",  date );
    console.log("value const ",  b );

  }
  return (
    <AppContainer title={'بروزرسانی اطلاعات کاربری'}>
      <Toaster />
      {userInfo !== null && UserInfoState? (
        <form dir={'rtl'} onSubmit={submitHandler} noValidate className='editForm'>
          <div className={'mt-3'}>
            <h3 className={'text-right'}>
              <BiUser className={'m-2'} />
              اطلاعات هویتی
            </h3>
            <hr className={'text-gray'} />
          </div>
          <MDBContainer className={'text-center w-100 mt-5  mb-2'} fluid={true}>
            <MDBRow>
              <MDBCol lg={'4'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'>نام </label>
                  <input
                    type='text'
                    name='name'
                    placeholder='لطفا نام خود را وارد کنید'
                    id='name'
                    value={userInfo.name}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>
              <MDBCol lg={'4'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'>نام خانوادگی </label>
                  <input
                    type='text'
                    name='lastname'
                    placeholder='لطفا   نام خانوادگی  خود را وارد کنید'
                    id='lastname'
                    value={userInfo.lastname}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>
              <MDBCol lg={'4'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'>نام پدر </label>
                  <input
                    type='text'
                    name='father_name'
                    placeholder='   نام  پدر خود را وارد کنید'
                    id='father_name'
                    value={userInfo.father_name}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>

              <MDBCol lg={'4'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> کد ملی </label>
                  <input
                    type='text'
                    placeholder='لطفا کد ملی خود را وارد کنید'
                    id='national_code'
                    name='national_code'
                    value={userInfo.national_code}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right '
                    )}
                  />
                </div>
              </MDBCol>
              {/* <MDBCol lg={'4'}> */}
                {/* <div className='row text-right mb-6 m-1'> */}
                  {/* <label className='col-form-label required fw-bold fs-6'> تاریخ تولد </label> */}
                  {/* <input
                    type='text'
                    placeholder='لطفا  تاریخ تولد  خود را وارد کنید'
                    id='birthday_date'
                    name='birthday_date'
                    value={userInfo.birthday_date}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  /> */}
                  {/* <DatePicker  className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'} /> */}
                {/* </div> */}
              {/* </MDBCol> */}
              <MDBCol lg={'4'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> آدرس ایمیل </label>
                  <input
                    type='email'
                    placeholder='آدرس ایمیل خود را وارد کنید'
                    id='email'
                    name='email'
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>
            </MDBRow>
            {/* /!* start row 2== اطلاعات شعلی و تماس *!/*/}
            <div className={'mt-3'}>
              <h3 className={'text-right'}>
                <MdWorkOutline className={'m-2'} />
                اطلاعات شغلی و تماس
              </h3>
              <hr className={'text-gray'} />
            </div>
            <MDBRow className=' text-right'>
              <MDBCol lg={'6'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> مدرک تحصیلی </label>
                  <input
                    type='text'
                    placeholder='لطفا مدرک تحصیلی  خود را وارد کنید'
                    id='degree'
                    name='degree'
                    value={userInfo.degree}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  '
                    )}
                  />
                </div>
              </MDBCol>

              <MDBCol lg={'6'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> شغل </label>
                  <input
                    type='text'
                    placeholder='لطفا شغل  خود را وارد کنید'
                    id='job_title'
                    name='job_title'
                    value={userInfo.job_title}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>

              <MDBCol lg={'6'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> شماره تلفن </label>
                  <input
                    type='text'
                    placeholder='لطفا  شماره تلفن  خود را وارد کنید'
                    id='phone_number'
                    name='phone_number'
                    value={userInfo.phone_number}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>
              <MDBCol lg={'6'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> موبایل </label>
                  <input
                    type='text'
                    placeholder='لطفا  شماره همراه  خود را وارد کنید'
                    id='mobile_number'
                    name='mobile_number'
                    value={userInfo.mobile_number}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>
              <MDBCol lg={'12'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> آدرس </label>
                  <input
                    type='text'
                    placeholder='لطفا  آدرس  خود را وارد کنید'
                    id='address'
                    name='address'
                    value={userInfo.address}
                    onChange={changeInput}
                    className={clsx(
                      'form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right '
                    )}
                  />
                </div>
              </MDBCol>
            </MDBRow>

            {/* start row 3 */}
            <div className={'mt-3'}>
              <h3 className={'text-right'}>
                <RiBankCard2Line className={'m-2'} />
                اطلاعات حساب بانکی
              </h3>
              <hr className={'text-gray'} />
            </div>
            <MDBRow>
              <MDBCol lg={'12'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> شماره شبا </label>
                  <input
                    type='text'
                    placeholder='لطفا   شماره شبا  خود را وارد کنید'
                    id='shaba_number'
                    name='shaba_number'
                    value={userInfo.shaba_number}
                    onChange={changeInput}
                    className={clsx(
                      'form-control text-center form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>

              <MDBCol lg={'6'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> نام بانک </label>
                  <input
                    type='text'
                    placeholder='لطفا   شماره شبا  خود را وارد کنید'
                    id='bank_name'
                    name='bank_name'
                    value={userInfo.bank_name}
                    onChange={changeInput}
                    className={clsx(
                      'form-control text-center form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right '
                    )}
                  />
                </div>
              </MDBCol>

              <MDBCol lg={'6'}>
                <div className='row text-right mb-6 m-1'>
                  <label className='col-form-label required fw-bold fs-6'> شماره حساب </label>
                  <input
                    type='text'
                    placeholder='لطفا   شماره حساب  خود را وارد کنید'
                    id='bank_account_number'
                    name='bank_account_number'
                    value={userInfo.bank_account_number}
                    onChange={changeInput}
                    className={clsx(
                      'form-control text-center form-control-lg form-control-solid mb-3 mb-lg-0 text-sm  text-right'
                    )}
                  />
                </div>
              </MDBCol>
            </MDBRow>
            <button
              type='submit'
              className=' btn bg-teal mt-8  text-white'
              onClick={() => submitHandler}
              // disabled={!formik.isValid}
            >
              {!loading ? 'ویرایش اطلاعات' : 'در حال ویرایش'}
            </button>
          </MDBContainer>
        </form>
      ) : (
        <Skeleton width={'100%'} height={'20%'} />
      )}
    </AppContainer>
  )
}

export default EditProfile
